import { useNavigate, Outlet } from 'react-router-dom'

import Filter from './Filter'
import Header from './Header'

import {
  FiArrowLeft,
  FiChevronLeft,
  FiChevronRight,
  FiHome
} from 'react-icons/fi'

import {
  RiPinDistanceFill
} from 'react-icons/ri'

import {
  PiSpeedometerDuotone
} from 'react-icons/pi'

import {
  CgSandClock
} from 'react-icons/cg'

const Statistics = () => {
  const navigate = useNavigate()

  const back = () => {
    navigate( '/main' )
  }

  return <section className="scroll one hs">
    { /* MAIN HEADER */ }
    <div className="bar">
      <button
        onClick={ back }
      >
        <FiArrowLeft />
      </button>

      <h1>statistics</h1>

      <Filter />
    </div>

    { /* MAIN */ }
    <div className="scroll one hs">

      <Header />

      <Outlet />

    </div>


    <div className="bar space-around">

      <button
        title="distance"
        onClick={ () => navigate( '/statistics/home' ) }
      >
        <FiHome />
      </button>

      <button
        title="distance"
        onClick={ () => navigate( '/statistics/distance' ) }
      >
        <RiPinDistanceFill />
      </button>

      <button
        title="speed"
        onClick={ () => navigate( '/statistics/speed' ) }
      >
        <PiSpeedometerDuotone />
      </button>

      <button
        title="time"
        onClick={ () => navigate( '/statistics/time' ) }
      >
        <CgSandClock />
      </button>

    </div>

  </section>
}

export default Statistics
